/**
 * Render the final JSX of MenuTrigger
 *
 * Only renders children
 */ export const renderToastTrigger_unstable = (state)=>state.children;
